import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import authReducer from "../features/auth/authSlice"
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";


// Configure persistant storage
const persistConfig = {
    key: "root",
    version: 1,
    storage,
    blacklist : ["apiKey"]
}

// Configure the store
export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        auth: persistReducer(persistConfig, authReducer),
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(apiSlice.middleware),
    devTools: true
})

// Export the persistant
export const persistor = persistStore(store)